import React from 'react';
import './Banner.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCalendarCheck, FaNotesMedical } from 'react-icons/fa';

import Bannerimg from "../assets/images/appointment_img.png";

const Banner = () => {
    return (
        <section className="banner-section">
            <div className="container banner-container-new">
                <div className="banner-content">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="banner-text"
                    >
                        <h2>Expert Care from <br /><span className="highlight-text">100+ Trusted Specialists</span></h2>
                        <p>Your health is our priority. Experience world-class medical care with our team of dedicated professionals ready to assist you.</p>

                        <div className="banner-actions">
                            <button className="btn-primary-gold" onClick={() => window.location.href = '/Contact'}>
                                <FaCalendarCheck /> Book Appointment
                            </button>
                            <Link to='/HealthTips' className="btn-outline-white">
                                <FaNotesMedical /> View Health Tips
                            </Link>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="banner-image-wrapper"
                    >
                        <img src={Bannerimg} alt="Doctor Consultation" className="banner-main-img" />
                        <div className="banner-glow-effect"></div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Banner;